import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "unVisitedComps",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Property Tabs Haven't Been Viewed")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Data for the following properties will not be imported / updated:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Click \"Save Viewed Properties\" if you'd like to proceed without this data.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning" }, "To send the additional properties to TOTAL, go to Configure Settings and enable \"Save all property data to TOTAL on save regardless of viewed status\".", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.compsList, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.compNumber
                  }, _toDisplayString(this.setCompAddress(item)), 1))
                }), 128))
              ])
            ]),
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveViewedProperties && _ctx.saveViewedProperties(...args)))
            }, " Save Viewed Properties "),
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}